"use strict";
/* tslint:disable */

/* eslint-disable */

/*
 * Copyright 2019 NEM
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Catapult REST Endpoints
 * OpenAPI Specification of catapult-rest
 *
 * The version of the OpenAPI document: 1.0.3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

var _defineProperty = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _inherits = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _wrapNativeSuper = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var _toConsumableArray = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _regeneratorRuntime = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _createForOfIteratorHelper = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextApiResponse = exports.BlobApiResponse = exports.VoidApiResponse = exports.JSONApiResponse = exports.canConsumeForm = exports.mapValues = exports.querystring = exports.exists = exports.Configuration = exports.COLLECTION_FORMATS = exports.RequiredError = exports.BaseAPI = exports.BASE_PATH = void 0;
exports.BASE_PATH = "http://localhost:3000".replace(/\/+$/, "");

var isBlob = function isBlob(value) {
  return typeof Blob !== 'undefined' && value instanceof Blob;
};
/**
 * This is the base class for all generated API classes.
 */


var BaseAPI = /*#__PURE__*/function () {
  function BaseAPI() {
    var _this = this;

    var configuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Configuration();

    _classCallCheck(this, BaseAPI);

    this.configuration = configuration;

    this.fetchApi = function (url, init) {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var fetchParams, _iterator, _step, middleware, response, _iterator2, _step2, _middleware;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                fetchParams = {
                  url: url,
                  init: init
                };
                _iterator = _createForOfIteratorHelper(this.middleware);
                _context.prev = 2;

                _iterator.s();

              case 4:
                if ((_step = _iterator.n()).done) {
                  _context.next = 15;
                  break;
                }

                middleware = _step.value;

                if (!middleware.pre) {
                  _context.next = 13;
                  break;
                }

                _context.next = 9;
                return middleware.pre(Object.assign({
                  fetch: this.fetchApi
                }, fetchParams));

              case 9:
                _context.t0 = _context.sent;

                if (_context.t0) {
                  _context.next = 12;
                  break;
                }

                _context.t0 = fetchParams;

              case 12:
                fetchParams = _context.t0;

              case 13:
                _context.next = 4;
                break;

              case 15:
                _context.next = 20;
                break;

              case 17:
                _context.prev = 17;
                _context.t1 = _context["catch"](2);

                _iterator.e(_context.t1);

              case 20:
                _context.prev = 20;

                _iterator.f();

                return _context.finish(20);

              case 23:
                _context.next = 25;
                return this.configuration.fetchApi(fetchParams.url, fetchParams.init);

              case 25:
                response = _context.sent;
                _iterator2 = _createForOfIteratorHelper(this.middleware);
                _context.prev = 27;

                _iterator2.s();

              case 29:
                if ((_step2 = _iterator2.n()).done) {
                  _context.next = 40;
                  break;
                }

                _middleware = _step2.value;

                if (!_middleware.post) {
                  _context.next = 38;
                  break;
                }

                _context.next = 34;
                return _middleware.post({
                  fetch: this.fetchApi,
                  url: url,
                  init: init,
                  response: response.clone()
                });

              case 34:
                _context.t2 = _context.sent;

                if (_context.t2) {
                  _context.next = 37;
                  break;
                }

                _context.t2 = response;

              case 37:
                response = _context.t2;

              case 38:
                _context.next = 29;
                break;

              case 40:
                _context.next = 45;
                break;

              case 42:
                _context.prev = 42;
                _context.t3 = _context["catch"](27);

                _iterator2.e(_context.t3);

              case 45:
                _context.prev = 45;

                _iterator2.f();

                return _context.finish(45);

              case 48:
                return _context.abrupt("return", response);

              case 49:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 17, 20, 23], [27, 42, 45, 48]]);
      }));
    };

    this.middleware = configuration.middleware;
  }

  _createClass(BaseAPI, [{
    key: "withMiddleware",
    value: function withMiddleware() {
      var _next$middleware;

      var next = this.clone();
      next.middleware = (_next$middleware = next.middleware).concat.apply(_next$middleware, arguments);
      return next;
    }
  }, {
    key: "withPreMiddleware",
    value: function withPreMiddleware() {
      for (var _len = arguments.length, preMiddlewares = new Array(_len), _key = 0; _key < _len; _key++) {
        preMiddlewares[_key] = arguments[_key];
      }

      var middlewares = preMiddlewares.map(function (pre) {
        return {
          pre: pre
        };
      });
      return this.withMiddleware.apply(this, _toConsumableArray(middlewares));
    }
  }, {
    key: "withPostMiddleware",
    value: function withPostMiddleware() {
      for (var _len2 = arguments.length, postMiddlewares = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        postMiddlewares[_key2] = arguments[_key2];
      }

      var middlewares = postMiddlewares.map(function (post) {
        return {
          post: post
        };
      });
      return this.withMiddleware.apply(this, _toConsumableArray(middlewares));
    }
  }, {
    key: "request",
    value: function request(context) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this$createFetchPara, url, init, response;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$createFetchPara = this.createFetchParams(context), url = _this$createFetchPara.url, init = _this$createFetchPara.init;
                _context2.next = 3;
                return this.fetchApi(url, init);

              case 3:
                response = _context2.sent;

                if (!(response.status >= 200 && response.status < 300)) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt("return", response);

              case 6:
                throw response;

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "createFetchParams",
    value: function createFetchParams(context) {
      var url = this.configuration.basePath + context.path;

      if (context.query !== undefined && Object.keys(context.query).length !== 0) {
        // only add the querystring to the URL if there are query parameters.
        // this is done to avoid urls ending with a "?" character which buggy webservers
        // do not handle correctly sometimes.
        url += '?' + this.configuration.queryParamsStringify(context.query);
      }

      var body = typeof FormData !== "undefined" && context.body instanceof FormData || context.body instanceof URLSearchParams || isBlob(context.body) ? context.body : JSON.stringify(context.body);
      var headers = Object.assign({}, this.configuration.headers, context.headers);
      var init = {
        method: context.method,
        headers: headers,
        body: body,
        credentials: this.configuration.credentials
      };
      return {
        url: url,
        init: init
      };
    }
    /**
     * Create a shallow clone of `this` by constructing a new instance
     * and then shallow cloning data members.
     */

  }, {
    key: "clone",
    value: function clone() {
      var constructor = this.constructor;
      var next = new constructor(this.configuration);
      next.middleware = this.middleware.slice();
      return next;
    }
  }]);

  return BaseAPI;
}();

exports.BaseAPI = BaseAPI;
;

var RequiredError = /*#__PURE__*/function (_Error) {
  _inherits(RequiredError, _Error);

  var _super = _createSuper(RequiredError);

  function RequiredError(field, msg) {
    var _this2;

    _classCallCheck(this, RequiredError);

    _this2 = _super.call(this, msg);
    _this2.field = field;
    _this2.name = "RequiredError";
    return _this2;
  }

  return _createClass(RequiredError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.RequiredError = RequiredError;
exports.COLLECTION_FORMATS = {
  csv: ",",
  ssv: " ",
  tsv: "\t",
  pipes: "|"
};

var Configuration = /*#__PURE__*/function () {
  function Configuration() {
    var configuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Configuration);

    this.configuration = configuration;
  }

  _createClass(Configuration, [{
    key: "basePath",
    get: function get() {
      return this.configuration.basePath != null ? this.configuration.basePath : exports.BASE_PATH;
    }
  }, {
    key: "fetchApi",
    get: function get() {
      return this.configuration.fetchApi || window.fetch.bind(window);
    }
  }, {
    key: "middleware",
    get: function get() {
      return this.configuration.middleware || [];
    }
  }, {
    key: "queryParamsStringify",
    get: function get() {
      return this.configuration.queryParamsStringify || querystring;
    }
  }, {
    key: "username",
    get: function get() {
      return this.configuration.username;
    }
  }, {
    key: "password",
    get: function get() {
      return this.configuration.password;
    }
  }, {
    key: "apiKey",
    get: function get() {
      var apiKey = this.configuration.apiKey;

      if (apiKey) {
        return typeof apiKey === 'function' ? apiKey : function () {
          return apiKey;
        };
      }

      return undefined;
    }
  }, {
    key: "accessToken",
    get: function get() {
      var accessToken = this.configuration.accessToken;

      if (accessToken) {
        return typeof accessToken === 'function' ? accessToken : function () {
          return accessToken;
        };
      }

      return undefined;
    }
  }, {
    key: "headers",
    get: function get() {
      return this.configuration.headers;
    }
  }, {
    key: "credentials",
    get: function get() {
      return this.configuration.credentials;
    }
  }]);

  return Configuration;
}();

exports.Configuration = Configuration;

function exists(json, key) {
  var value = json[key];
  return value !== null && value !== undefined;
}

exports.exists = exists;

function querystring(params) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return Object.keys(params).map(function (key) {
    var fullKey = prefix + (prefix.length ? "[".concat(key, "]") : key);
    var value = params[key];

    if (value instanceof Array) {
      var multiValue = value.map(function (singleValue) {
        return encodeURIComponent(String(singleValue));
      }).join("&".concat(encodeURIComponent(fullKey), "="));
      return "".concat(encodeURIComponent(fullKey), "=").concat(multiValue);
    }

    if (value instanceof Object) {
      return querystring(value, fullKey);
    }

    return "".concat(encodeURIComponent(fullKey), "=").concat(encodeURIComponent(String(value)));
  }).filter(function (part) {
    return part.length > 0;
  }).join('&');
}

exports.querystring = querystring;

function mapValues(data, fn) {
  return Object.keys(data).reduce(function (acc, key) {
    return Object.assign(Object.assign({}, acc), _defineProperty({}, key, fn(data[key])));
  }, {});
}

exports.mapValues = mapValues;

function canConsumeForm(consumes) {
  var _iterator3 = _createForOfIteratorHelper(consumes),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var consume = _step3.value;

      if ('multipart/form-data' === consume.contentType) {
        return true;
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return false;
}

exports.canConsumeForm = canConsumeForm;

var JSONApiResponse = /*#__PURE__*/function () {
  function JSONApiResponse(raw) {
    var transformer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (jsonValue) {
      return jsonValue;
    };

    _classCallCheck(this, JSONApiResponse);

    this.raw = raw;
    this.transformer = transformer;
  }

  _createClass(JSONApiResponse, [{
    key: "value",
    value: function value() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.t0 = this;
                _context3.next = 3;
                return this.raw.json();

              case 3:
                _context3.t1 = _context3.sent;
                return _context3.abrupt("return", _context3.t0.transformer.call(_context3.t0, _context3.t1));

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }]);

  return JSONApiResponse;
}();

exports.JSONApiResponse = JSONApiResponse;

var VoidApiResponse = /*#__PURE__*/function () {
  function VoidApiResponse(raw) {
    _classCallCheck(this, VoidApiResponse);

    this.raw = raw;
  }

  _createClass(VoidApiResponse, [{
    key: "value",
    value: function value() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", undefined);

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
    }
  }]);

  return VoidApiResponse;
}();

exports.VoidApiResponse = VoidApiResponse;

var BlobApiResponse = /*#__PURE__*/function () {
  function BlobApiResponse(raw) {
    _classCallCheck(this, BlobApiResponse);

    this.raw = raw;
  }

  _createClass(BlobApiResponse, [{
    key: "value",
    value: function value() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.raw.blob();

              case 2:
                return _context5.abrupt("return", _context5.sent);

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }]);

  return BlobApiResponse;
}();

exports.BlobApiResponse = BlobApiResponse;

var TextApiResponse = /*#__PURE__*/function () {
  function TextApiResponse(raw) {
    _classCallCheck(this, TextApiResponse);

    this.raw = raw;
  }

  _createClass(TextApiResponse, [{
    key: "value",
    value: function value() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.raw.text();

              case 2:
                return _context6.abrupt("return", _context6.sent);

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
  }]);

  return TextApiResponse;
}();

exports.TextApiResponse = TextApiResponse;